import { render, staticRenderFns } from "./RegisterH5.vue?vue&type=template&id=70ba2a31&scoped=true&"
import script from "./RegisterH5.vue?vue&type=script&lang=js&"
export * from "./RegisterH5.vue?vue&type=script&lang=js&"
import style0 from "./RegisterH5.vue?vue&type=style&index=0&id=70ba2a31&scoped=true&lang=css&"
import style1 from "./RegisterH5.vue?vue&type=style&index=1&id=70ba2a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba2a31",
  null
  
)

component.options.__file = "RegisterH5.vue"
export default component.exports